<template>
    <div class="page-catalogue">
        <h1>{{ bookName }}</h1>
        <perfect-scrollbar ref="appScrollbar" :options="{ suppressScrollX: true }">
            <div class="detail-content">
                <u-catalogue :bookId="bookId" :bookName="bookName" />
            </div>
        </perfect-scrollbar>
        <div class="detail-footer">
            <div v-if="prev" @click="onPage(-1)"><span>上一页:</span><a>{{ prev.bookName }}</a></div>
            <div v-if="next" @click="onPage(1)"><span>下一页:</span><a>{{ next.bookName }}</a></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        bookId: {
            type: String,
            default: ""
        },
        bookName: {
            type: String,
            default: ""
        },
    },
    watch: {
        bookId() {
            this.getData();
        }
    },
    computed: {
        ...mapGetters(["bookList"]),
        bookIndex() {
            return this.bookList.findIndex(i => i.bookId == this.bookId)
        },
        prev() {
            let index = this.bookIndex - 1;
            return index >= 0 ? this.bookList[index] : null;
        },
        next() {
            let index = this.bookIndex + 1;
            return index < this.bookList.length ? this.bookList[index] : null;
        },
    },
    data() {
        return {

        };
    },
    methods: {
        onPage(index) {
            if (index > 0) {
                this.jump(`/pageCatalogue/${this.next.bookId}/${this.next.bookName}`)
            } else {
                this.jump(`/pageCatalogue/${this.prev.bookId}/${this.prev.bookName}`)
            }
        },
        formatData(list, index) {
            let level = 'level' + index;
            let item = list.find(i => i[level] == 0);
            if (item) {
                let l1 = list.filter(i => i[level] != 0);
                let ids = [];
                l1.forEach(i => {
                    if (!ids.includes(i[level])) {
                        ids.push(i[level])
                    }
                });
                item.children = ids.map(i => {
                    let l2 = l1.filter(j => j[level] == i);
                    if (l2.length) {
                        return this.formatData(l2, index + 1)
                    }
                })
            }
            return item;
        },
        toList(list, parent) {
            let arr = [];
            list.forEach(i => {
                if (i) {
                    arr.push({
                        id: i.id,
                        bookId: i.bookId,
                        biaoTi: i.biaoTi,
                        parent
                    })
                    if (i && i.children && i.children.length) {
                        arr.push(...this.toList(i.children, i.id))
                    }
                }
            })
            return arr;
        },
        getData() {
            this.$store.dispatch("getBookDetail", {
                bookId: this.bookId, // 书名Id 
            })

            /*             
            let obj = {
                bookId: this.bookId, // 书名Id 
            };
            this.$store.commit("showLoading");
            this.api("getBookDetail", obj).then(res => {
                this.$store.commit("hideLoading");
                let list = res.result;
                list.unshift({
                    "level1": "0",
                })
                let d = this.formatData(list, 1)
                let arr = this.toList(d.children, 0);
                this.$store.commit("setCatalogueList", arr)
                this.$store.commit("setCatalogueTree", d.children)
            }); */
        }
    },
    created() {
        this.getData();
    },
}
</script>

<style lang="scss" scoped>
.page-catalogue {
    padding-top: 30px;
    h1 {
        margin: 0 0 10px 0;
    }

    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
</style>